import { createRouter, createWebHistory } from 'vue-router';
import checkAuth from '@/middleware/checkAuth';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Creates a `nextMiddleware()` function which runs the default `next()` callback and triggers the next Middleware function in the chain.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    if (
      parameters.length === 0 ||
      (parameters.length === 1 && parameters[0] === undefined)
    ) {
      const nextMiddleware = nextFactory(context, middleware, index + 1);
      subsequentMiddleware({ ...context, next: nextMiddleware });
    } else {
      context.next(...parameters);
    }
  };
}

// Global middleware - checkAuth runs first, then any route-specific middleware
const globalMiddleware = [checkAuth];

router.beforeEach((to, from, next) => {
  // Skip all middleware for the Unauthorized route to prevent redirect loops
  if (to.name === 'Unauthorized' || to.path === '/unauthorized') {
    // console.log('Skipping middleware for Unauthorized route');
    return next();
  }

  // Route-specific middleware
  const routeMiddleware = to.meta.middleware
    ? Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]
    : [];

  const middleware = [...globalMiddleware, ...routeMiddleware];

  // Create a context object
  const context = {
    from,
    next,
    router,
    to,
  };

  const nextMiddleware = nextFactory(context, middleware, 1);

  // Call the first middleware function in the array
  if (middleware.length) {
    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;
